import { render, staticRenderFns } from "./giftPopup.vue?vue&type=template&id=23a7c64e&scoped=true"
import script from "./giftPopup.vue?vue&type=script&lang=js"
export * from "./giftPopup.vue?vue&type=script&lang=js"
import style0 from "./giftPopup.vue?vue&type=style&index=0&id=23a7c64e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a7c64e",
  null
  
)

export default component.exports